export const WHITE_LIST_MIME_IMAGES = ['image/jpeg', 'image/pjpeg', 'image/png'];
export const S3_PATH = process.env.VUE_APP_S3_PATH;
export default {};
